<template>
  <pill-button
    :to="`/${collection.id}`"
    :label="collection.label"
    :year="collection.year"
    class="button"
  >
    <span
      v-if="$isMobile"
      class="notice"
    >{{ yeardate }}</span>
  </pill-button>
</template>

<script>
import PillButton from '@/components/common/buttons/PillButton.vue';

export default {
  name: 'HomeCollectionItem',
  components: {
    PillButton,
  },
  props: {
    collection: {
      type: Object,
      required: true,
    },
  },

  computed: {
    yeardate() {
      return this.$config.common.yeardate_label.format({ year: this.collection.year });
    },
  },
};
</script>

<style lang="stylus" scoped>
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  &.router-link-active {
    +mobile() {
      display: none;
    }
  }

  .notice {
    font-size: 14px;
    font-weight: 300;
    font-style: italic;
    color: var(--text-color);
  }
}
</style>
